<div class="app-main__inner">

  <!-- ── Book form ─────────────────────────────────────────────── -->
  <div class="bb-form-view">
  <div class="bb-form-card">

    <div class="bb-form-header">
      <div class="bb-form-header__title">
        <i class="pe-7s-bookmarks"></i> New Book
        <span class="bb-session-badge ms-3" *ngIf="booksAddedCount > 0">
          <i class="pe-7s-check me-1"></i>{{ booksAddedCount }} added
        </span>
      </div>
      <button type="button" class="bb-form-header__back" (click)="goToDashboard()">
        <i class="pe-7s-angle-left"></i> Back
      </button>
    </div>

    <app-book-form (saved)="onBookSaved($event)"></app-book-form>

  </div>
  </div>

</div>


<!-- ── Add Copy Modal ─────────────────────────────────────────── -->
<div class="bm-ac-backdrop" *ngIf="showAddCopyModal" (click)="closeAddCopyModal()"></div>
<div class="bm-ac-modal" *ngIf="showAddCopyModal" (click)="$event.stopPropagation()">

  <div class="bm-ac-header">
    <div class="bm-ac-title"><i class="pe-7s-plus me-2 text-primary"></i>Add Copies</div>
    <button type="button" class="bm-ac-close" (click)="closeAddCopyModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="bm-ac-book-strip">
    <div class="bm-ac-book-icon"><i class="pe-7s-notebook"></i></div>
    <div class="bm-ac-book-name">{{ addCopyBook?.bookName }}</div>
    <span class="bm-ac-book-id" *ngIf="addCopyBook?.bookId">{{ addCopyBook.bookId }}</span>
  </div>

  <!-- Step 1: Form -->
  <div class="bm-ac-body" *ngIf="addCopyStep === 'form'">

    <div class="bm-ac-field">
      <label class="bm-ac-label">Number of Copies</label>
      <input type="number" class="form-control form-control-sm" style="max-width:120px;"
             min="1" max="200" [(ngModel)]="addCopyCopies">
    </div>

    <div class="bm-ac-field mt-3">
      <label class="bm-ac-label">Center</label>
      <div *ngIf="centersLoading" class="text-muted small">
        <span class="spinner-border spinner-border-sm me-1"></span>Loading centers…
      </div>
      <select class="form-select form-select-sm" style="max-width:320px;"
              *ngIf="!centersLoading" [(ngModel)]="addCopyCenterId">
        <option value="">— Select center —</option>
        <option *ngFor="let c of centers" [value]="c._id">{{ c.centerName }}</option>
      </select>
    </div>

    <div class="alert alert-danger py-2 px-3 small mt-3" *ngIf="addCopyError">
      <i class="pe-7s-attention me-1"></i>{{ addCopyError }}
    </div>

    <div class="bm-ac-footer mt-4">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeAddCopyModal()">
        Skip
      </button>
      <button type="button" class="btn btn-primary btn-sm"
              (click)="createCopies()" [disabled]="addCopyIsCreating">
        <span *ngIf="addCopyIsCreating" class="spinner-border spinner-border-sm me-1"></span>
        <i *ngIf="!addCopyIsCreating" class="pe-7s-diskette me-1"></i>
        {{ addCopyIsCreating ? 'Creating…' : 'Create' }}
      </button>
    </div>
  </div>

  <!-- Step 2: Result -->
  <div class="bm-ac-body" *ngIf="addCopyStep === 'result'">

    <div class="bm-ac-success">
      <i class="pe-7s-check bm-ac-success-icon"></i>
      <div class="bm-ac-success-text">
        {{ addCopyGeneratedSrNos.length }} cop{{ addCopyGeneratedSrNos.length === 1 ? 'y' : 'ies' }} created successfully!
      </div>
    </div>

    <div class="bm-ac-srnos">
      <div class="bm-ac-srnos-label">Assigned Sr. Numbers:</div>
      <div class="bm-ac-srnos-list">
        <span *ngFor="let n of addCopyGeneratedSrNos" class="bm-ac-srno-chip">
          {{ padSrNo(n) }}
        </span>
      </div>
    </div>

    <div class="bm-ac-print-ask">Print barcode labels?</div>
    <div class="bm-ac-footer mt-2">
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeAddCopyModal()">
        No
      </button>
      <button type="button" class="btn btn-primary btn-sm" (click)="printAndClose()">
        <i class="pe-7s-print me-1"></i>Yes, Print
      </button>
    </div>

  </div>
</div>
